import { z } from 'zod'
import { optionalText, requiredText } from '../../../lib/forms/rules'

/** Ret gerekçesi ekle/düzenle form şeması (020): nameTr zorunlu; nameEn opsiyonel. Sıra formda yok (tablodan). */
export const rejectReasonFormSchema = z.object({
  nameTr: requiredText(),
  nameEn: optionalText(),
})

export type RejectReasonFormValues = z.infer<typeof rejectReasonFormSchema>
